import { useEffect, useState } from "react";
import {
  LiveKitRoom,
  AudioConference,
  VideoConference,
  RoomAudioRenderer,
  ControlBar,
} from "@livekit/components-react";
import "@livekit/components-styles";

/**
 * props：
 * - userId: 使用者名稱
 * - roomName: 房間名稱
 * - mode: "audio" 或 "video"
 */
export default function CallRoom({ kind, id, mode = "video", token: tokenProp, wsUrl: wsUrlProp }) {
  const [token, setToken] = useState(tokenProp || null);
  const [wsUrl, setWsUrl] = useState(wsUrlProp || null);
  const [roomName, setRoomName] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setToken(tokenProp || null);
    setWsUrl(wsUrlProp || null);
  }, [tokenProp, wsUrlProp]);

  useEffect(() => {
    console.log("CallRoom mode =", mode, "kind =", kind, "id =", id);
  }, [mode, kind, id]);

  // 取得 token & LiveKit server URL
  useEffect(() => {
    if (tokenProp && wsUrlProp) return;
    let cancelled = false;
    async function fetchToken() {
      try {
        // const res = await fetch(
        //   `http://localhost:5000/livekit-token?user=${encodeURIComponent(userId)}&room=${encodeURIComponent(roomName)}`
        // );
        // const data = await res.json();
        // setToken(data.token);
        // setWsUrl(data.ws_url);
        setError(null);
        setToken(null);
        setWsUrl(null);
        setRoomName(null);

        const res = await fetch(`http://localhost:5000/api/rtc/token`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          // credentials: "include", // 你目前 JWT/cookie 的做法
          body: JSON.stringify({ kind, id }),
        });

        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.error || "取得 token 失敗");
        }

        if (cancelled) return;

        console.log("rtc/token response =", data);


        setToken(data.token);
        setWsUrl(data.ws_url);
        setRoomName(data.room_name);
      } catch (err) {
        console.error("取得 token 發生錯誤:", err);
        if (!cancelled) setError(err.message || "取得 token 發生錯誤");
      }
    }

    if (kind && id) fetchToken();

    return () => {
      cancelled = true;
    };
  }, [kind, id, tokenProp, wsUrlProp]);

  if (error) return <div style={{ padding: 12 }}>❌ {error}</div>;
  if (!token || !wsUrl) {
    return <div>連線準備中…</div>;
  }

  return (
    <LiveKitRoom
      token={token}
      serverUrl={wsUrl}
      connect={true}
      video={mode === "video"}
      audio={true}
      style={{ height: "100vh" }}
    >
      {/* 播放房間內所有人的音訊 */}
      <RoomAudioRenderer />

      {/* 視訊 or 純語音 UI */}
      {mode === "audio" ? <AudioConference /> : <VideoConference />}

      {/* 控制按鈕：mic、camera、screen share、離開 */}
      <ControlBar
        controls={{
          microphone: true,
          camera: true,
          screenShare: true,
          leave: true,
        }}
      />
    </LiveKitRoom>
  );
}
